import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Modal } from '@lt/components';
import FullScreenPreloader from '../../../components/Auth/FullScreenPreloader';
import withMobile from '../hocs/withMobile';

const ProcessingOverlay = ({ overlayMessage, isMobile }) =>
  overlayMessage && (
    <StyledModal shadow={false} isMobile={isMobile}>
      <FullScreenPreloader text={overlayMessage} />
    </StyledModal>
  );

const StyledModal = styled(Modal)`
  background-color: rgba(0, 0, 0, 0.35);
  ${({ isMobile }) =>
    isMobile &&
    css`
      background-color: rgba(255, 255, 255, 0.5);
    `}
`;

ProcessingOverlay.propTypes = {
  overlayMessage: PropTypes.string,
  isMobile: PropTypes.bool,
};
ProcessingOverlay.defaultProps = {
  overlayMessage: null,
  isMobile: false,
};

export default withMobile(ProcessingOverlay);
